var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamond({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8576 0L20 5.625H16.4896L14.0868 0H16.8576ZM12.4132 0L14.816 5.625H5.18403L7.58681 0H12.4132ZM3.14236 0H5.91319L3.51042 5.625H0L3.14236 0ZM0 6.75H3.49653L7.76736 15.5988C7.81944 15.7078 7.67361 15.8062 7.59375 15.7148L0 6.75ZM5.14583 6.75H14.8542L10.0972 17.9367C10.0625 18.0211 9.94097 18.0211 9.90625 17.9367L5.14583 6.75ZM12.2326 15.5988L16.5035 6.75H20L12.4062 15.7113C12.3264 15.8062 12.1806 15.7078 12.2326 15.5988Z",
    fill: "#FFC500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.253f030eff5222f25aa7929b8b981359.svg";
export { ForwardRef as ReactComponent };